// Modules
// import { Button } from '@dasa-health/components-react'
import { BottomSheet } from 'components'
import React, { ReactNode, useEffect } from 'react'
import { useTracking } from 'react-tracking'
import { CustomModalDuvidas } from 'redesign/components/atoms/CustomModalDuvidas'
import { Icon } from '@dasa-health/alma-react'
import { Close, Whatsapp } from '@dasa-health/alma-icons'

// Application
import { userDeviceDetect } from 'utils'

// Components
import {
    BottomSheetContent,
    BottomSheetTitle,
    BottomSheetWrapper,
    BottomSheetButtonWrapper,
    BottomSheetTitleContainer,
    CustomButton,
} from './styles'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'

export interface SignUpModalProps {
    showModal: boolean
    setShowModal: (isOpen: boolean) => void
    title?: string
    children?: ReactNode
}

export const SignUpModalDuvidas = ({ showModal, setShowModal, title, children }: SignUpModalProps) => {
    const { trackEvent } = useTracking()
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    const { isPortable } = userDeviceDetect()

    const buttonData = {
        label: 'Acessar WhatsApp',
        href: 'https://api.whatsapp.com/send/?phone=551140202117',
        icon: <Whatsapp />,
        taget: '_blank',
    }

    function trackEventModal() {
        if (biometyDataLS.origin === UNICO_CONSTANTS.ORIGIN.OTP) {
            return trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: 'login_faseado',
                    current_step: 'Modal Dúvidas Central de Atendimento',
                },
            })
        }

        if (biometyDataLS.origin === UNICO_CONSTANTS.ORIGIN.RECOVER) {
            return trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: 'password_reset',
                    current_step: 'Modal Dúvidas Central de Atendimento',
                },
            })
        }

        return trackEvent({
            event: 'nav_signup_funnel',
            funnel: {
                name: 'cadastro_web',
                current_step: 'Modal Dúvidas Central de Atendimento',
            },
            user: {
                has_mdm: true,
            },
        })
    }

    function currentService() {
        if (biometyDataLS.origin === UNICO_CONSTANTS.ORIGIN.OTP) {
            return 'Login faseado'
        }

        if (biometyDataLS.origin === UNICO_CONSTANTS.ORIGIN.RECOVER) {
            return 'Reset Senha'
        }

        return 'Cadastro'
    }

    useEffect(() => {
        showModal && trackEventModal()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showModal])

    return (
        <>
            {showModal && !isPortable && (
                <CustomModalDuvidas
                    buttonData={buttonData}
                    currentService={currentService}
                    onClose={() => setShowModal(false)}
                    open={showModal}
                    title={title}
                >
                    {children}
                </CustomModalDuvidas>
            )}
            {showModal && isPortable && (
                <BottomSheet isOpen={showModal} onRequestClose={() => setShowModal(!showModal)}>
                    <BottomSheetWrapper>
                        <BottomSheetTitleContainer>
                            {title && <BottomSheetTitle>{title}</BottomSheetTitle>}{' '}
                            <button data-testid="close-button" onClick={() => setShowModal(false)} type="button">
                                <Icon size="lg">
                                    <Close />
                                </Icon>
                            </button>
                        </BottomSheetTitleContainer>
                        {children && <BottomSheetContent>{children}</BottomSheetContent>}
                        <BottomSheetButtonWrapper>
                            <CustomButton
                                data-current-service={currentService()}
                                data-item-position="Modal Dúvidas Central de Atendimento"
                                data-item-text={buttonData.label}
                                href={buttonData.href}
                                target={buttonData.taget}
                                title={buttonData.label}
                                type="button"
                            >
                                {buttonData.icon && <Icon size="lg">{buttonData.icon}</Icon>}
                                {buttonData.label}
                            </CustomButton>
                        </BottomSheetButtonWrapper>
                    </BottomSheetWrapper>
                </BottomSheet>
            )}
        </>
    )
}
